import React from "react";
import BoqTablePage from "./BoqTablePage";

const App: React.FC = () => {
  return <BoqTablePage />;
};

export default App;